import React from 'react';
import './Our_product_card.css';

function Our_product_card({ imgSrc, title, subTitle }) {
    return (
        <section className='Our_product_card'>
            <div className='img_holder'>
                <img
                    className="product_img"
                    src={process.env.PUBLIC_URL + imgSrc}
                    alt={title}
                />
            </div>
            <div className="text_holder">
                <h4>{title}</h4>
                <p>{subTitle}</p>
            </div>
            <div className='View_Details_btn_holder'>
                <p>View Details</p>
            </div>
        </section>
    );
}

export default Our_product_card;
